export default __webpack_public_path__ + "static/media/myoffer.841af215.svg";